import type { TextPlaceholderLine } from '@/shared/types/marketplace.interface';
import { TextPlaceholder } from '@/components/Common';
import classNames from 'classnames';
import './index.less';
const ProductPlaceholder = ({ textLines = [] }: { textLines?: TextPlaceholderLine[] }) => {
  return (
    <div className="product-placeholder">
      <div
        className={classNames('image', {
          'full-width': !(textLines.length > 0),
        })}
      ></div>
      {textLines.length > 0 && (
        <div className="content">
          <TextPlaceholder lines={textLines} />
        </div>
      )}
    </div>
  );
};

export default ProductPlaceholder;
